if(!global["m"]) global["m"] = {};
module.exports = global["m"]["bidi"] = require("-!.\\bidi.js");